var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputeRunning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9DCF889C-1F13-4785-9D19-0573E593567F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-56.000000, -524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RUNNING",
    transform: "translate(19.000000, 424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16x16/Compute/Paused-Copy",
    transform: "translate(37.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-box",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#74AE43",
    cx: 17.8010108,
    cy: 17.8010108,
    r: 14.653371
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5892857,24.75 C16.3878348,24.75 17.0357143,24.1021205 17.0357143,23.3035714 L17.0357143,12.6964286 C17.0357143,11.8978795 16.3878348,11.25 15.5892857,11.25 L12.6964286,11.25 C11.8978795,11.25 11.25,11.8978795 11.25,12.6964286 L11.25,23.3035714 C11.25,24.1021205 11.8978795,24.75 12.6964286,24.75 L15.5892857,24.75 Z M23.3035714,24.75 C24.1021205,24.75 24.75,24.1021205 24.75,23.3035714 L24.75,12.6964286 C24.75,11.8978795 24.1021205,11.25 23.3035714,11.25 L20.4107143,11.25 C19.6121652,11.25 18.9642857,11.8978795 18.9642857,12.6964286 L18.9642857,23.3035714 C18.9642857,24.1021205 19.6121652,24.75 20.4107143,24.75 L23.3035714,24.75 Z",
    id: "\\uF04C",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputeRunning);
export default __webpack_public_path__ + "static/media/compute-running.e73393965ba589f979541e9205195e8f.svg";
export { ForwardRef as ReactComponent };